define('product_views_option_empty_template.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('product_views_option_empty_template', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true}, 'extensions/TavanoTeam/ItemOptionEmptyTemplate/1.0.0/', 'extensions/TavanoTeam/ItemOptionEmptyTemplate/1.0.0/', Handlebars);
});